module.exports = (function() { // http://stackoverflow.com/questions/19999388/jquery-check-if-user-is-using-ie

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);

})();  
